import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, REACT_APP_API_BASE_URL, url } from "../Config/Config";
import { CODE, StorageConstant, VALIDATION_MESSAGE } from "../Constants/Constants";
import { getBrowserTimezone } from "../utils/DateTimeHelper";
import { clearStorage, getItemFromStorage, removeItemFromStorage } from "../utils/Helper";


const token = getItemFromStorage(StorageConstant?.is_admin_login_token)
const apiinstance = axios.create({
  baseURL: REACT_APP_API_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Methods": "PUT, GET, POST, DELETE, OPTIONS",
    "Authorization": `Bearer ${token}`,
    "device_type": "web",
    "timezone": getBrowserTimezone()

  }
})

const apiinstanceFormData = axios.create({
  baseURL: REACT_APP_API_BASE_URL,
  headers: {
    Accept: "application/json",
    'Content-Type': 'multipart/form-data',
    "Access-Control-Allow-Origin": "",
    "Access-Control-Allow-Headers": "",
    "Access-Control-Allow-Methods": "PUT, GET, POST, DELETE, OPTIONS",
    "Authorization": `Bearer ${token}`,
    "device_type": "web",
    "timezone": getBrowserTimezone()
  }
})

const apiinstanceBuffer = axios.create({
  baseURL: REACT_APP_API_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Methods": "PUT, GET, POST, DELETE, OPTIONS",
    "Authorization": `Bearer ${token}`,
    "device_type": "web",
    "timezone": getBrowserTimezone()
  },
  responseType: 'blob', // Set responseType to 'blob'
});

const apiinstanceUrlEncodedData = axios.create({
  baseURL: REACT_APP_API_BASE_URL,
  headers: {
    // Accept: "application/json",
    'Content-Type': 'application/x-www-form-urlencoded',
    "Access-Control-Allow-Origin": "",
    "Access-Control-Allow-Headers": "",
    "Access-Control-Allow-Methods": "PUT, GET, POST, DELETE, OPTIONS",
    "Authorization": `Bearer ${token}`,
    "device_type": "web",
    "timezone": getBrowserTimezone()
  }
})

const handleLogOut = () => {
  removeItemFromStorage(StorageConstant?.is_admin_login_token);
  window.location.href = BASE_URL + "/"
}
export const POSTAPI = (URL: string, params: any, toastStatus: any = true) => {
  const promise = apiinstance.post(URL, params, {
    validateStatus: status => status >= 200 && status < 600
  });
  const dataPromise = promise.then((response) => response).then((response) => {
    if (response?.status === CODE?.OK_CODE || response?.status === CODE?.CREATED) {
      if (toastStatus || response?.status === CODE?.OK_CODE  ) { toast.success(response.data?.message) }
      if (response?.data?.status) {
        // toast.success(response.data?.message);
        return response.data;
      }
      else if (response?.data?.status_code === CODE?.NO_CONTENT) {
        return response?.data;

      }
      else {
        toast.error(response.data?.message);
        return response.data;
      }
    }
    else if (response?.status === CODE?.BAD_REQUEST_CODE) {
      toast.error(response.data?.message);
      return response?.data;
    }
    else if (response?.status === CODE?.UNAUTHORIZED_CODE) {
      toast.error(response.data?.message);
      clearStorage();
      sessionStorage.clear()
      window.location.href = BASE_URL + '/'
    }
    else if (response?.status === CODE?.INTERNAL_SERVER_ERROR) {
      toast.error(response.data?.message);
      return response?.data;

    }
    else if (response?.status === CODE?.VALIDATION_CODE) {
      toast.error(response.data?.message);
      return response?.data;

    }
    else {
      toast.error(VALIDATION_MESSAGE?.CATCH_ERROR);
    }
  }).catch((error) => {
    // return error;   
    if (error?.response?.status === CODE?.UNAUTHORIZED_CODE) {
      handleLogOut()
    }
    toast.error(VALIDATION_MESSAGE?.CATCH_ERROR);
  });
  return dataPromise;
};

export const POSTAPIFORMDATA = (URL: string, params: any, toastStatus: any = true) => {
  const promise = apiinstanceFormData.post(URL, params, {
    validateStatus: status => status >= 200 && status < 600
  });
  const dataPromise = promise.then((response) => response).then((response) => {
    
    // console.log(toastStatus ,"ghjkl",response?.status === CODE?.OK_CODE || response?.status === CODE?.CREATED ,"fggg" , response?.status)
    if (response?.status === CODE?.OK_CODE || response?.status === CODE?.CREATED) {
      if (toastStatus) { toast.success(response.data?.message) }
      if (response?.data?.status) {
        // toast.success(response.data?.message);
        return response.data;
      }
      else if (response?.data?.status_code === CODE?.NO_CONTENT) {
        return response?.data;

      }
      else {
        toast.error(response.data?.message);
        return response.data;
      }
    }
    else if (response?.status === CODE?.BAD_REQUEST_CODE) {
      toast.error(response.data?.message);
      return response?.data;
    }
    else if (response?.status === CODE?.UNAUTHORIZED_CODE) {
      toast.error(response.data?.message);
      clearStorage();
      sessionStorage.clear()
      window.location.href = BASE_URL + '/'
    }
    else if (response?.status === CODE?.INTERNAL_SERVER_ERROR) {
      toast.error(response.data?.message);
      return response?.data;

    }
    else if (response?.status === CODE?.VALIDATION_CODE) {
      toast.error(response.data?.message);
      return response?.data;

    }
    else {
      toast.error(VALIDATION_MESSAGE?.CATCH_ERROR);
    }
  }).catch((error) => {
    // return error;   
    if (error?.response?.status === CODE?.UNAUTHORIZED_CODE) {
      handleLogOut()
    }
    toast.error(VALIDATION_MESSAGE?.CATCH_ERROR);
  });
  return dataPromise;
};
export const GETAPI = (URL: string, params: any = {}, toastStatus: any = false) => {
  const promise = apiinstance.get(URL, params)

  const dataPromise = promise.then((response) => response).then((response) => {
    if (response?.status === 200 || response?.status === 201) {
      //  toast.success(response.data?.message)
      if (toastStatus) { toast.success(response.data?.message) }
      return response.data;
    } else {
      toast.error(response.data?.message)
      return response?.data;
    }
  }).catch((error) => {
    if (error?.response?.status === CODE?.UNAUTHORIZED_CODE) {
      handleLogOut()
    }
  })
  return dataPromise;
}


export const PDFPOSTAPI = (URL: string, params: any, toastStatus: any = true) => {
  const promise = apiinstanceBuffer.post(URL, params, {
    validateStatus: status => status >= 200 && status < 600
  });

  return promise

};